/* One way to sign up: every email ask on the site is a button that opens Klaviyo's store credit
   pop-up. layout/theme.liquid loads this file and hands it the two form ids from Theme settings,
   Sign up pop-up, on the script tag.

   HF.openSignup(trigger, opts) opens the phone or the desktop form and remembers what opened it:
   trigger is the button's data-hf-trigger (header, cartons-home, carton-shop and so on), opts.carton
   the carton someone tapped, opts.el the element whose ask ([data-hf-ask],
   snippets/hf-signup-ask.liquid) shows the fallback. If Klaviyo has not opened a form within
   OPEN_WAIT, that ask's line says so and its email box opens (snippets/hf-signup-fallback.liquid);
   where there is no ask (the header, the phone menu, the sticky bar) the one box under the header
   opens instead. The box sends the email to our own sign up route (App
   supabase/functions/site-signup), which subscribes it to the pop-up's Klaviyo list with the same
   attribution, and the box says it worked in place.

   Any [data-hf-notify] element opens it on click; its href is only for a browser without
   JavaScript. Klaviyo's form subscribes the email itself but sends none of the site's attribution,
   so every sign up, the timed pop-up's and the box's included, adds it to the profile with
   klaviyo.identify and fires the PostHog email_signup and the Meta Lead.

   The pop-up's email gets the same slip check as our own forms (snippets/hf-email-check.liquid)
   before Klaviyo sees it. */
(function () {
  var HF = (window.HF = window.HF || {});
  if (HF.openSignup) return;

  var me = document.currentScript;
  var FORMS = {
    phone: me ? me.getAttribute('data-form-mobile') : '',
    wide: me ? me.getAttribute('data-form-desktop') : ''
  };
  /* Klaviyo shows a form by device from the user agent, not the screen width, so a width rule would
     ask a tablet or a narrow desktop window for a form Klaviyo will not draw there. These are its own
     tests, copied from static.klaviyo.com/onsite/js/sharedUtils.2c9ede6ce511c.js (module 29410),
     read 2026-10-16. */
  var MOBILE_A = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
  var MOBILE_B = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
  /* klaviyo.js can arrive late on a slow phone; an open that lands after this still puts the box away. */
  var OPEN_WAIT = 2500;
  /* The box under the header goes on its own after this, unless someone is in it or has typed. */
  var BOX_FOR = 15000;
  var SOURCE = 'HfreeO pop-up';
  var BOX_SOURCE = 'HfreeO email box';
  var FAILED = "The pop-up didn't load, so here's the short version.";
  var DONE = "You're on the list. When you make your HfreeO app account, the 6 extra cans will be waiting in it.";
  var BAD_EMAIL = "That email doesn't look right. Mind checking it?";
  /* The coming soon page's words for the same two moments. */
  var NOT_SAVED = "Couldn't save that. Try again, or email hello@hfreeo.com.";
  var SAVING = 'Saving…';
  /* Longer than the route's own two Klaviyo calls can take, so a slow answer is never cut off. */
  var SEND_WAIT = 20000;
  var FIRST_TOUCH = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

  /* A sign up no button asked for came from the timed pop-up. */
  var last = { trigger: 'timed', carton: null };
  var asked = null;
  var showing = null;
  var waiting = 0;
  var shown = null;
  var pageBox = document.querySelector('[data-hf-fallback-float]');
  var pageOff = 0;
  var opener = null;

  function eventId() {
    return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
  }

  function isPhone() {
    var ua = navigator.userAgent || navigator.vendor || window.opera || '';
    return !!window.klaviyoForceMobile || MOBILE_A.test(ua) || MOBILE_B.test(ua.substr(0, 4));
  }

  /* The box under the header sits just below the bar, wherever the bar is right now, so it never
     covers the header button. */
  function openPage() {
    var top = Math.max(0, document.querySelector('[data-hf-chrome] [data-hf-bar]').getBoundingClientRect().bottom) + 8;
    pageBox.style.top = top + 'px';
    pageBox.style.maxHeight = 'calc(100dvh - ' + (top + 8) + 'px)';
    pageBox.hidden = false;
    clearTimeout(pageOff);
    pageOff = setTimeout(function () {
      if (pageBox.contains(document.activeElement) || pageBox.querySelector('[name="email"]').value) return;
      closePage();
    }, BOX_FOR);
  }

  function closePage() {
    clearTimeout(pageOff);
    var inside = pageBox.contains(document.activeElement);
    pageBox.hidden = true;
    pageBox.querySelector('[data-hf-signup-fail]').textContent = '';
    if (shown && shown.box === pageBox) shown = null;
    if (inside && opener) opener.focus();
  }

  function clearFail() {
    clearTimeout(waiting);
    if (shown) {
      shown.line.textContent = '';
      if (shown.box === pageBox) closePage();
      else shown.box.hidden = true;
    }
    shown = null;
  }

  function fail(el) {
    /* A form already on screen sends no second open, and the pop-up is working. */
    if (showing) return;
    var ask = el && el.closest ? el.closest('[data-hf-ask]') : null;
    var box = ask ? ask.querySelector('[data-hf-fallback]') : pageBox;
    var line = (ask || box).querySelector('[data-hf-signup-fail]');
    var fresh = box === pageBox && box.hidden;
    if (box === pageBox) openPage();
    else box.hidden = false;
    shown = { line: line, box: box };
    /* A live region that has only just joined the page is not heard, so the words wait a beat. */
    setTimeout(function () { if (shown && shown.line === line) line.textContent = FAILED; }, fresh ? 100 : 0);
  }

  /* Where a sign up came from: the first touch, the button and any carton tapped. */
  function attribution() {
    var ft = (typeof window.hfFirstTouch === 'function') ? window.hfFirstTouch() : {};
    var properties = {};
    FIRST_TOUCH.forEach(function (key) { if (ft[key]) properties[key] = ft[key]; });
    if (ft.landing) properties.signup_landing = ft.landing;
    if (ft.referrer) properties.signup_referrer = ft.referrer;
    /* Only a carton someone tapped counts. */
    if (last.carton) properties.carton_interest = last.carton;
    properties.signup_trigger = last.trigger;
    return properties;
  }

  function signedUp(email, source, properties) {
    properties = properties || attribution();
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      var profile = { email: email };
      Object.keys(properties).forEach(function (key) { profile[key] = properties[key]; });
      window.klaviyo.identify(profile);
    }
    /* Person first, so the signup event lands on a person rather than as a personless event. */
    if (window.hfPerson) window.hfPerson(email);
    if (window.hfEvent) window.hfEvent('email_signup', { source: source, carton: properties.carton_interest || null, trigger: last.trigger });
    /* The browser half of the Lead. meta-pixel.liquid holds the event until consent. */
    if (typeof window.hfTrack === 'function') {
      window.hfTrack('Lead', { content_name: source }, { eventID: eventId() });
    }
    last = { trigger: 'timed', carton: null };
  }

  HF.openSignup = function (trigger, opts) {
    opts = opts || {};
    clearFail();
    /* A carton tapped earlier still counts if the pop-up then opens from another button. */
    last = { trigger: trigger || 'unknown', carton: opts.carton || last.carton };
    asked = isPhone() ? FORMS.phone : FORMS.wide;
    opener = opts.el || null;
    waiting = setTimeout(function () { fail(opts.el); }, OPEN_WAIT);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', asked]);
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-hf-fallback-close]')) { closePage(); return; }
    var el = e.target.closest('[data-hf-notify]');
    if (!el) return;
    e.preventDefault();
    HF.openSignup(el.getAttribute('data-hf-trigger') || 'unknown', { el: el });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && pageBox && !pageBox.hidden) closePage();
  });

  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-hf-fallback]');
    if (!box) return;
    e.target.removeAttribute('aria-invalid');
    box.querySelector('[data-hf-fallback-msg]').textContent = '';
  });

  document.addEventListener('submit', function (e) {
    var box = e.target.closest('[data-hf-fallback]');
    if (!box) return;
    e.preventDefault();
    var form = e.target;
    var input = form.querySelector('[name="email"]');
    var msg = box.querySelector('[data-hf-fallback-msg]');
    var btn = form.querySelector('[type="submit"]');
    if (btn.disabled) return;
    if (typeof window.hfEmailCheck === 'function') {
      var check = window.hfEmailCheck(input.value);
      if (!check.ok) { msg.textContent = BAD_EMAIL; input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
      if (check.suggestion && window.hfEmailAsk(input, msg, check.suggestion)) return;
    }
    var email = input.value.trim();
    var properties = attribution();
    var label = btn.textContent;
    /* Read before the button is disabled, which takes focus off it. */
    var inside = form.contains(document.activeElement);
    btn.disabled = true;
    btn.textContent = SAVING;
    msg.textContent = '';
    fetch(form.action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, website: form.querySelector('[name="website"]').value, properties: properties }),
      signal: (window.AbortSignal && AbortSignal.timeout) ? AbortSignal.timeout(SEND_WAIT) : undefined
    }).then(function (res) {
      if (!res.ok) throw new Error('site-signup ' + res.status);
    }).then(function () {
      form.hidden = true;
      msg.textContent = DONE;
      /* The form has gone, so focus moves to the line that replaced it. */
      if (inside) { msg.tabIndex = -1; msg.focus(); }
      /* After the success line, and outside the failure path: a tracker that throws must never
         read as a sign up that did not save. */
      signedUp(email, BOX_SOURCE, properties);
    }, function () {
      btn.disabled = false;
      btn.textContent = label;
      msg.textContent = NOT_SAVED;
      if (inside) btn.focus();
    });
  });

  /* Klaviyo's submit is the first button after the email field, or Enter in it. Capture runs before
     Klaviyo's own handlers on those elements. Any shape that is not that, and any address the check
     calls not ok, is left to Klaviyo. */
  function slipCheck(e) {
    var form = e.target.closest && e.target.closest('form[data-testid^="klaviyo-form-"]');
    if (!form || typeof window.hfEmailCheck !== 'function') return;
    var input = form.querySelector('input[name="email"]');
    if (!input) return;
    if (e.type === 'click') {
      var button = e.target.closest('button');
      var submit = Array.prototype.find.call(form.querySelectorAll('button'), function (b) {
        return input.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING;
      });
      if (!button || button !== submit) return;
    }
    var check = window.hfEmailCheck(input.value);
    if (!check.ok || !check.suggestion) return;
    var msg = form.querySelector('.hf-kl-ask');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'hf-kl-ask';
      msg.setAttribute('role', 'alert');
      /* Under the field inside its own column: the form's rows and components are flex rows, where a sibling would squeeze the field. */
      input.insertAdjacentElement('afterend', msg);
      form.addEventListener('input', function () { msg.replaceChildren(); });
    }
    if (window.hfEmailAsk(input, msg, check.suggestion)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  document.addEventListener('click', slipCheck, true);
  document.addEventListener('submit', slipCheck, true);

  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.formId !== FORMS.phone && d.formId !== FORMS.wide) return;
    if (d.type === 'close') { showing = null; return; }
    if (d.type === 'open') {
      if (d.formId === showing) return;
      showing = d.formId;
      if (asked && d.formId === asked) asked = null;
      else last = { trigger: 'timed', carton: last.carton };
      /* The pop-up takes focus now, so putting the box away must not hand it back to the button. */
      opener = null;
      clearFail();
      return;
    }
    if (d.type !== 'submit') return;
    var email = d.metaData && d.metaData.$email;
    if (email) signedUp(email, SOURCE);
  });
})();
